module.exports = __webpack_public_path__ + "img/public/AdminIcons/backArrow.svg?c4abf780";